// React 19 hoistet <title>/<meta>/<link> in den <head>. So bleibt die
// Client-Navigation konsistent zum prerenderten HTML (Canonical + OG).
const OG_IMAGE = "https://rechnerkiste.de/og-image.png";

export const Seo = ({ title, description, canonical }) => (
  <>
    <title>{title}</title>
    <meta name="description" content={description} />
    {canonical && <link rel="canonical" href={canonical} />}
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    {canonical && <meta property="og:url" content={canonical} />}
    <meta property="og:type" content="website" />
    <meta property="og:image" content={OG_IMAGE} />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:image" content={OG_IMAGE} />
  </>
);
